import { render, staticRenderFns } from "./space-grading.vue?vue&type=template&id=0fcd4b04&scoped=true"
import script from "./space-grading.vue?vue&type=script&lang=js"
export * from "./space-grading.vue?vue&type=script&lang=js"
import style0 from "./space-grading.vue?vue&type=style&index=0&id=0fcd4b04&prod&lang=less&scoped=true"
import style1 from "./space-grading.vue?vue&type=style&index=1&id=0fcd4b04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd4b04",
  null
  
)

export default component.exports